import { AxiosError } from 'axios';
import instance from '../config/axios';
import { AddSasBApprovalProps } from '../interface/interface';

export const addSasBApproval = async (props: AddSasBApprovalProps) => {
  try {
    const response = await instance({
      method: 'POST',
      url: `/api/v1/sasb/approval`,
      data: { orderId: props.orderId, data: props.data },
      headers: {
        Authorization: `Bearer ${props.token}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log((e as AxiosError).response);
    return (e as AxiosError).response?.status;
  }
};
